import apiVersion from '../_helpers/api-version';
import queryString from 'query-string';
import axiosInstance from '../_helpers/axiosConfig';

import { store } from '../_helpers/store';
import { authHeader } from '../_helpers/auth-header'

export const intakeService = {
  search,
  exportToken,
};

function exportToken(searchParams) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/intake/export-token`,
    data: { ...searchParams }
  }).then((response) => {
    return response.data;
  })
}

function search(params = {}) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/intake?${queryString.stringify(params)}`,
  }).then((response) => {
    return response.data;
  })
}